import { TableColumnsType } from "antd";
import { useCallback, useMemo } from "react";
import { AuditType } from "../../../../types/auditTypes";
import DropdownOptionsAuditTypes from "../components/DropdownOptionsAuditTypes/DropdownOptionsAuditTypes";

type Options = {
  onModify: (id: number) => void;
  onDelete: (id: number) => void;
};

export default function useTableAuditTypes({ onModify, onDelete }: Options) {
  const columns = useMemo(() => {
    const _columns: TableColumnsType<AuditType> = [
      {
        title: "CODE",
        dataIndex: "code",
        key: "code",
        align: "left",
        width: 120,
        sorter: true,
        sortDirections: ["ascend", "descend"],
      },
      {
        title: "NOM",
        dataIndex: "name",
        key: "name",
        align: "left",
        sorter: true,
        sortDirections: ["ascend", "descend"],
      },
      {
        title: "DESCRIPTION",
        dataIndex: "description",
        key: "description",
        align: "left",
        sorter: true,
        sortDirections: ["ascend", "descend"],
      },
      {
        title: "",
        dataIndex: "",
        align: "center",
        key: "actions",
        width: 10,
        render: (_, item) => (
          <DropdownOptionsAuditTypes
            itemId={item.id}
            onModify={onModify}
            onDelete={onDelete}
          />
        ),
      },
    ];
    return _columns;
  }, [onModify, onDelete]);

  const onRowClick = useCallback(
    (record: AuditType) => ({ onClick: () => onModify(record.id) }),
    [onModify],
  );

  return { columns, onRowClick };
}
